export const portfolioData = [
  {
    id: 1,
    name: "E-Commerce",
    description:
      "E-commerce website delivers a streamlined shopping experience. Explore multiple product categories, customize selections, and effortlessly manage your cart. It's shopping made simple and enjoyable.",
    technologies: ["React.js", "Css", "React-Router", "React Class Component"],
    repoLink: "https://github.com/NikaGogelia/E-Commerce",
    webLink: undefined,
  },
  {
    id: 2,
    name: "Music App",
    description:
      "Crafted a Spotify-inspired music app using the Spotify API. Explore a vast music library, create custom playlists, and enjoy tailored recommendations. Your go-to for a personalized and immersive musical journey.",
    technologies: [
      "React.js",
      "Css",
      "Bootstrap",
      "React-Router",
      "React-Query",
      "Swiper.js",
      "Animate.css",
    ],
    repoLink: "https://github.com/NikaGogelia/Music-App",
    webLink: undefined,
  },
  {
    id: 3,
    name: "Digital Clock App",
    description:
      "This is Digital Clock App with some information about current time, date, weather conditions and current timezone. It was built by React. I have used some apis to get that data..",
    technologies: ["React.js", "Css", "Bootstrap"],
    repoLink: "https://github.com/NikaGogelia/Digital-Clock-App",
    webLink: undefined,
  },
  {
    id: 4,
    name: "Where In The World",
    description:
      "'Where In The World?' Is Educative Website Where You Can Learn About Countries Around The World. You Are Able To Get Information About Country's Territory, Language, Currency, Flag, Location And Etc.",
    technologies: ["Html", "Css", "Javascript", "Bootstrap", "Rest Api"],
    repoLink: "https://github.com/NikaGogelia/Where-In-The-World",
    webLink: "https://nikagogelia.github.io/Where-In-The-World/",
  },
  {
    id: 5,
    name: "Async Race",
    description:
      "Experience the pinnacle of racing with our Async Race website. Effortlessly manage cars with create, delete, and update features. Engage in thrilling races and track winners seamlessly. Elevate your racing passion with professional-grade precision.",
    technologies: ["Html", "Css", "Javascript"],
    repoLink: "https://github.com/NikaGogelia/Async-Race",
    webLink: undefined,
  },
  {
    id: 6,
    name: "Magic Massage Website",
    description:
      "This is Magic Massage product landing page with responsive design and some little features which includes: slideshow of cards, FAQ dropdowns and other.",
    technologies: ["Html", "Css", "Javascript"],
    repoLink: "https://github.com/NikaGogelia/MagicMassage",
    webLink: "https://nikagogelia.github.io/MagicMassage/",
  },
  {
    id: 7,
    name: "Online Zoo Website",
    description:
      "Online-zoo is a platform that contains information about animals from various zoos with webcams. It is assumed that a user can open the page with zoo resources, observe one of the animals, or make a donation that will be used to purchase food. ",
    technologies: ["Html", "Css", "Javascript"],
    repoLink: "https://github.com/NikaGogelia/Online-Zoo",
    webLink: "https://nikagogelia.github.io/Online-Zoo/pages/main/index.html",
  },
  {
    id: 8,
    name: "Space Tourism Website",
    description:
      "This is Space Tourism Agency Website built with HTML, CSS and Javascript. This website shows important information about planets, crew of space ship and technology that will be used to reach the destination.",
    technologies: ["Html", "Css", "Javascript", "Bootstrap"],
    repoLink: "https://github.com/NikaGogelia/Space-Tourism",
    webLink: "https://nikagogelia.github.io/Space-Tourism/index.html",
  },
];
